module.exports = __webpack_public_path__ + "static/media/file.f5842458.svg";